shadow$provide[280] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Readback:{enumerable:true, get:function() {
  return Readback;
}}});
var require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js = require("../../primitive.js");
class Readback extends require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js.Primitive {
  static initClass() {
    this.traits = ["node", "bind", "operator", "readback", "entity", "active"];
    this.finals = {channels:4};
  }
  init() {
    this.emitter = this.root = null;
    return this.active = {};
  }
  make() {
    super.make();
    this._compute("readback.data", () => this.readback != null ? this.readback.data : undefined);
    this._compute("readback.items", () => this.readback != null ? this.readback.items : undefined);
    this._compute("readback.width", () => this.readback != null ? this.readback.width : undefined);
    this._compute("readback.height", () => this.readback != null ? this.readback.height : undefined);
    this._compute("readback.depth", () => this.readback != null ? this.readback.depth : undefined);
    this._helpers.bind.make([{to:"operator.source", trait:"source"}]);
    if (this.bind.source == null) {
      return;
    }
    const {type, channels, expr} = this.props;
    this.root = this._inherit("root");
    this._listen("root", "root.update", this.update);
    const {items, width, height, depth} = this.bind.source.getDimensions();
    const sampler = this.bind.source.sourceShader(this._shaders.shader());
    this.readback = this._renderables.make("readback", {map:sampler, items, width, height, depth, channels, type,});
    if (expr != null) {
      this.readback.setCallback(expr);
    }
    this._helpers.active.make();
  }
  unmake() {
    if (this.readback != null) {
      this.readback.dispose();
      this.readback = null;
      this.root = null;
      this.emitter = null;
      this.active = {};
    }
    this._helpers.active.unmake();
    return this._helpers.bind.unmake();
  }
  update() {
    if (this.readback == null) {
      return;
    }
    if (this.isActive) {
      this.readback.update(this.root != null ? this.root.getCamera() : undefined);
      this.readback.post();
      if (this.props.expr != null) {
        this.readback.iterate();
      }
    }
  }
  resize() {
    let sI, sJ;
    if (this.readback == null) {
      return;
    }
    const {items, width, height, depth} = this.bind.source.getActiveDimensions();
    this.readback.setActive(items, width, height, depth);
    this.strideI = sI = items;
    this.strideJ = sJ = sI * width;
    return this.strideK = sJ * height;
  }
  change(changed, _touched, _init) {
    if (changed["readback.type"]) {
      return this.rebuild();
    }
    if (changed["readback.expr"] && this.readback) {
      return this.readback.setCallback(this.props.expr);
    }
  }
}
Readback.initClass();

};